import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var FlagDe = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { fill: "#ffce00", d: "M0 341.338h512.005v170.67H0z" }),
    React.createElement("path", { fill: "#000", d: "M0 0h512.005v170.67H0z" }),
    React.createElement("path", { fill: "#d00", d: "M0 170.67h512.005v170.668H0z" })), '0 0 512 512', 'FlagDe');
//# sourceMappingURL=FlagDe.js.map